import styled from 'styled-components';
import { PropertyCardBadgeMixin } from '../../mixins/components/PropertyCardBadgeMixin';
export var StyledPropertyCardBadge = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledPropertyCardBadge",
  componentId: "c11n-8-111-1__sc-tmjrig-0"
})(["", ""], PropertyCardBadgeMixin);